export default "__VITE_ASSET__CeM_B8W5__"